export var fadeIn = {
    hide: {
        opacity: 0
    },
    show: {
        opacity: 1
    }
};

//# sourceMappingURL=fadeIn.js.map